import { ALL_SESSION_STATUS_DISPLAYS } from '@efdigital/ll-addon-coaching/utils/coaching-sessions/session-display';
import {
  CANCELLED_KEYS,
  HISTORY_KEYS,
} from '@efdigital/ll-addon-coaching/utils/coaching-sessions/session-lifecycle';
import type { CoachingSessionStatus } from '@efdigital/ll-addon-data';

export type SessionStatusGroup = {
  label: string;
  statuses: CoachingSessionStatus[];
  title: string;
};

const ADMIN_UPCOMING_KEYS: CoachingSessionStatus[] = [
  'awaiting_coach_confirmation',
  'scheduled',
];

const ADMIN_COMPLETED_KEYS: CoachingSessionStatus[] = [
  'external_change_flagged',
  'awaiting_attendance_review',
  'completed',
  'attended',
  'resolved',
  'auto_resolved',
];

const NEEDS_ATTENTION_BY_ADMIN_KEYS: CoachingSessionStatus[] = [
  'external_change_flagged',
  'awaiting_attendance_review',
];

const NEEDS_ATTENTION_BY_USER_KEYS: CoachingSessionStatus[] = [
  'awaiting_coach_confirmation',
  'external_change_flagged',
  'completed',
];

export const SESSION_STATUS_GROUPS: SessionStatusGroup[] = [
  {
    label: 'Upcoming',
    title: 'Upcoming sessions',
    statuses: ADMIN_UPCOMING_KEYS,
  },
  {
    label: 'History',
    title: 'Past sessions',
    statuses: HISTORY_KEYS,
  },
  {
    label: 'Cancelled',
    title: 'Cancelled sessions',
    statuses: CANCELLED_KEYS,
  },
  {
    label: 'Needs attention by user',
    title: 'Sessions needing attention by a user',
    statuses: NEEDS_ATTENTION_BY_USER_KEYS,
  },
  {
    label: 'Needs attention by admin',
    title: 'Sessions needing attention by an admin',
    statuses: NEEDS_ATTENTION_BY_ADMIN_KEYS,
  },
  {
    label: 'Completed',
    title: 'Completed sessions',
    statuses: ADMIN_COMPLETED_KEYS,
  },
];

export function findSessionStatusGroup(
  selectedStatuses: CoachingSessionStatus[]
): SessionStatusGroup | null {
  for (const group of SESSION_STATUS_GROUPS) {
    if (
      selectedStatuses.length === group.statuses.length &&
      group.statuses.every((status) => selectedStatuses.includes(status))
    ) {
      return group;
    }
  }
  return null;
}

export function isAllStatuses(
  selectedStatuses: CoachingSessionStatus[]
): boolean {
  return (
    selectedStatuses.length === ALL_SESSION_STATUS_DISPLAYS.length ||
    selectedStatuses.length === 0
  );
}

export function isCustomStatuses(
  selectedStatuses: CoachingSessionStatus[]
): boolean {
  return (
    !isAllStatuses(selectedStatuses) &&
    !findSessionStatusGroup(selectedStatuses)
  );
}
